import styles from "./index.module.less";
import { ButtonField } from "@wk/components-react16";
import { useNavigate } from "react-router-dom";

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className={styles["privacyPolicy-view"]}>
      <div className="title">用户隐私和服务条款</div>
      <div className="content">
        <div className="first">
          <div className="content-title">一、总则</div>
          <div className="content-body">
            <div className="content-text">
              1.1　用户应当同意本协议的条款并按照页面上的提示完成全部的注册程序。用户在进行注册程序过程中勾选"我已阅读并接受"模块即表示用户与产品名称达成协议，完全接受本协议项下的全部条款。
            </div>
            <div className="content-text">
              1.2　用户注册成功后，产品名称将给予每个用户一个用户帐号及相应的密码，该用户帐号和密码由用户负责保管；用户应当对以其用户帐号进行的所有活动和事件负法律责任。
            </div>
            <div className="content-text">
              1.3　用户可以使用产品名称各个频道单项服务，当用户使用产品名称各单项服务时，用户的使用行为视为其对该单项服务的服务条款以及产品名称在该单项服务中发出的各类公告的同意。
            </div>
          </div>
        </div>

        <div className="second">
          <div className="content-title">二、注册信息和隐私保护</div>
          <div className="content-body">
            <div className="content-text">
              2.1　产品名称帐号（即产品名称用户ID）的所有权归产品名称，用户完成注册申请后，获得产品名称帐号的使用权。所有原始键入的资料将引用为注册资料。如果因注册信息不真实而引起的问题，并对问题发生所带来的后果，产品名称不负任何责任。
            </div>
            <div className="content-text">
              2.2　用户不应将其帐号、密码转让或出借予他人使用。如用户发现其帐号遭他人非法使用，应立即通知产品名称。因黑客行为或用户的保管疏忽导致帐号、密码遭他人非法使用，产品名称不承担任何责任。
            </div>
            <div className="content-textList">
              <div className="content-text">
                2.3　产品名称不对外公开或向第三方提供单个用户的注册资料，除非：
              </div>
              <div className="content-text">• 事先获得用户的明确授权；</div>
              <div className="content-text">
                • 只有透露您的个人资料，才能提供您所要求的产品和服务；
              </div>
              <div className="content-text">• 根据有关的法律法规要求；</div>
              <div className="content-text">• 按照相关政府主管部门的要求；</div>
              <div className="content-text">• 为维护产品名称的合法权益。</div>
            </div>

            <div className="content-text">
              2.4　在您注册产品名称，使用其他产品名称产品或服务，访问产品名称网页时，产品名称会收集您的个人身份识别资料，并会将这些资料用于：改进为你提供的服务及网页内容。
            </div>
          </div>
        </div>

        <div className="third">
          <div className="content-title">三、使用规则</div>
          <div className="content-body">
            <div className="content-textList">
              <div className="content-text">
                3.1　用户在使用产品名称服务时，必须遵守中华人民共和国相关法律法规的规定，用户应同意将不会利用本服务进行任何违法或不正当的活动，包括但不限于下列行为：
              </div>
              <div className="content-text">
                • 上载、展示、张贴、传播或以其它方式传送含有下列内容之一的信息：
              </div>
              <div className="content-text">
                • 不得为任何非法目的而使用网络服务系统；
              </div>

              <div className="content-text">
                • 不利用产品名称服务从事以下活动：
              </div>

              <div className="content-text">
                • 未经允许，进入计算机信息网络或者使用计算机信息网络资源的；
              </div>

              <div className="content-text">
                • 未经允许，对计算机信息网络功能进行删除、修改或者增加的；
              </div>

              <div className="content-text">
                •
                未经允许，对进入计算机信息网络中存储、处理或者传输的数据和应用程序进行删除、修改或者增加的；
              </div>

              <div className="content-text">
                • 故意制作、传播计算机病毒等破坏性程序的；
              </div>

              <div className="content-text">
                • 其他危害计算机信息网络安全的行为。
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="btn">
        <ButtonField mode={"ghost"}>
          <button
            type="button"
            onClick={() => {
              navigate(-1);
            }}
          >
            返回
          </button>
        </ButtonField>
      </div>
    </div>
  );
};
export default PrivacyPolicy;
